module.exports = __webpack_public_path__ + "img/carlosTok.b9d4643c.jpg";